export default __webpack_public_path__ + "static/media/404.1f9709cc.png";